// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2342":"8378897a","6002":"6d0c46de"}[chunkId] + ".chunk.css";
};